import type { PortalCapability } from '../../../shared/roles.js';
import type { Me } from '../../lib/me.js';

export function canViewGrowthPerformance(me: Me | null, hasCap: (capability: PortalCapability) => boolean, mfaBlocked: boolean): boolean {
  return me?.role === 'admin' && hasCap('users:manage') && hasCap('org:view') && hasCap('view:all') && !mfaBlocked;
}

export const GROWTH_PARAMS = { q: 'growthQuery', activity: 'growthActivity', agreements: 'growthAgreements', page: 'growthPage' } as const;

/** Keep saved report links and their roster filters working inside Overview. */
export function legacyGrowthPath(params: URLSearchParams, hash = ''): string {
  const next = new URLSearchParams({ overviewView: 'growth' });
  for (const [oldKey, key] of Object.entries(GROWTH_PARAMS)) {
    const value = params.get(oldKey);
    if (value) next.set(key, value);
  }
  return `/?${next}${hash}`;
}
